import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { User } from "../../interfaces/user";
import defaultAvatar from "../../assets/images/avatar.svg";
import { ProfileEdit } from "./profile-edit";
import { whoami } from "../../services/user";
import { UserContext } from "../../App";

export default function UserWidget() {
    const location = useLocation();
    const { pathname } = location;
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const [showMenu, setShowMenu] = useState(false);
    const [showEditUser, setShowEditUser] = useState(false);
    
    const { userProfile } = useContext(UserContext);

    const handleShowMenu = () => {
        setShowMenu(!showMenu);
    }

    const handleLogout = (event: any) => {
        event.preventDefault();
        localStorage.removeItem('token');
        navigate("/");
        window.location.reload();
    }

    const handleEditUserClick = () => {
        setShowMenu(false);
        setShowEditUser(true);
    }

    const handleProfileSave = (profile: User) => {
        whoami()
            .then((whoamiResponse: any) => {
                const userProfile: User = {
                    id: whoamiResponse.data.id,
                    name: whoamiResponse.data.name,
                    email: whoamiResponse.data.user_email,
                    first_name: whoamiResponse.data.firstname,
                    last_name: whoamiResponse.data.surname,
                    birthdate: whoamiResponse.data.birthdate,
                    phone: whoamiResponse.data.phone,
                    document_id: whoamiResponse.data.document_id,
                    description: whoamiResponse.data.description,
                    slug: whoamiResponse.data.slug,
                    role: whoamiResponse.data.role,
                    // meta: whoamiResponse.data.meta.map((m: any) => { return m; }),
                    avatar: whoamiResponse.data.avatar,
                    club: whoamiResponse.data.club,
                    teams: whoamiResponse.data.teams,
                    reference_id: whoamiResponse.data.reference_id,
                    status: whoamiResponse.data.status,
                    garmin_last_refresh: whoamiResponse.data.garmin_last_refresh,
                    garmin_access_token: whoamiResponse.data.garmin_access_token,
                    garmin_refresh_token: whoamiResponse.data.garmin_refresh_token,
                    garmin_expires_in: whoamiResponse.data.garmin_expires_in,
                    garmin_scope: whoamiResponse.data.garmin_scope,
                    garmin_jti: whoamiResponse.data.garmin_jti,
                    garmin_refresh_token_expires_in: whoamiResponse.data.garmin_refresh_token_expires_in,
                    garmin_user_id: whoamiResponse.data.garmin_user_id,
                    created: whoamiResponse.data.created,
                    changed: whoamiResponse.data.changed,
                }
                if (userProfile.status == 0) {
                    localStorage.removeItem('token');
                } else {
                    localStorage.setItem('user_profile', JSON.stringify(userProfile));
                }
                setShowEditUser(false);
            })
            .catch(whoamiError => {
                console.log(whoamiError);
            });
    }

    const handleProfileClose = () => {
        setShowEditUser(false);
    }

    const handleCloseUserMenu = (event: any) => {
        event.preventDefault();
        setShowMenu(false);
    }

    return (
        <div className="user-widget">
            <div className="action">
                <div className="inner">
                    <img src={ userProfile.avatar.length > 0 ? userProfile.avatar[0].url : defaultAvatar } onClick={ handleShowMenu } />
                    <div className="title">{ t("User") }</div>
                </div>
            </div>
            { showMenu && 
                <div className="user-menu">
                    <div className="user-name">
                        { userProfile.name }
                        <a href="#" className="close" onClick={ handleCloseUserMenu }></a>
                    </div>
                    <div className="user-menu-items">
                        <ul>
                            <li>
                                <a href="#" onClick={ handleEditUserClick }>{ t('edit_profile') }</a>
                            </li>
                            <li>
                                <a href="#" onClick={ handleLogout }>{ t('exit') }</a>
                            </li>
                        </ul>
                    </div>
                </div>
            }
            { showEditUser &&
                <ProfileEdit id={ userProfile.id } role={ userProfile.role } referenceId={ userProfile.reference_id } onSave={ handleProfileSave } onClose={ handleProfileClose }/>
            }  
        </div>
    );
}
